import { saveAs } from "file-saver";
import { Workbook } from "exceljs";

export const saveExcel = async (data, columns, fileName) => {
  try {
    // Create a workbook and a worksheet
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("Worksheet-1");

    // Add column headers
    worksheet.columns = columns;

    const firstRow = worksheet.getRow(1);

    // Apply styles to the first row
    firstRow.eachCell((cell) => {
      cell.font = { bold: true, color: { argb: "FFFFFFFF" }, size: 14 };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "5d44ff" },
      };
      cell.alignment = { horizontal: "center", vertical: "middle" };
    });

    // Adjust the height of the first row
    firstRow.height = 20;

    // Add sample rows
    const rows = data;

    if (rows.length === 0) {
      throw new Error("No data available to export!");
    }

    // updated the font for first row.
    worksheet.getRow(1).font = { bold: true };

    // loop through all of the columns and set the alignment with width.
    worksheet.columns.forEach((column) => {
      column.width = column.header.length + 5;
      column.alignment = { horizontal: "center" };
    });

    // loop through data and add each one to worksheet
    rows.forEach((singleData) => {
      worksheet.addRow(singleData);
    });

    // loop through all of the rows and set the outline style.
    worksheet.eachRow({ includeEmpty: false }, (row) => {
      // store each cell to currentCell
      const currentCell = row._cells;

      // loop through currentCell to apply border only for the non-empty cell of excel
      currentCell.forEach((singleCell) => {
        // store the cell address i.e. A1, A2, A3, B1, B2, B3, ...
        const cellAddress = singleCell._address;

        // apply border
        worksheet.getCell(cellAddress).border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });
    });

    // Generate the Excel file
    const buffer = await workbook.xlsx.writeBuffer();

    // Save the file using file-saver
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, `${fileName}.xlsx`);
  } catch (error) {
    console.error("Failed to export data:", error.message);
  }
};
